import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { LeftPane } from 'page/catalog/BoutiqueHeader/LeftPane'
import { RightPane } from 'page/catalog/BoutiqueHeader/RightPane'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { ui } from 'store/home/ui/HomeUiStore'
import css from './BoutiqueHeader.module.scss'

export const BoutiqueHeader = observer(() => {
  const { small } = ui.window
  const client = !!employee.user && !small

  return <Space className={css.header} gap={16} opposite oh>
    <LeftPane />
    {client && <RightPane />}
  </Space>
})
